// import { UrlContext } from "../../contexts/UrlContext";
// import React, { useContext, useEffect, useState } from "react";

// const CopyUrlComponent = ({ projectID, url, setUrl, handleOpenEmail }) => {
//   const [copied, setCopied] = useState(false);
//   const [tokenData, setTokenData] = useState();
//   const [loading, setLoading] = useState(true);
//   const [code, setCode] = useState("");
//   const { API_URL } = useContext(UrlContext);

//   // Estado para controlar la visualización del modal y el valor del slider
//   const [showModal, setShowModal] = useState(false);
//   const [durationIndex, setDurationIndex] = useState(0);
//   // Mapeo de posiciones: índice 0 => 30 días, 1 => 2 meses, 2 => 6 meses, 3 => 1 año
//   const durations = [30, 60, 180, 365];
//   const labels = ["30 days (recommended)", "2 months", "6 months", "1 year"];

//   const copyToClipboard = () => {
//     navigator.clipboard.writeText(url).then(() => {
//       setCopied(true);
//       setTimeout(() => setCopied(false), 2000);
//     });
//   };

//   useEffect(() => {
//     if (url.includes("http")) {
//       fetch(`${API_URL}validate_code`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ code: url.split("&code=")[1] }),
//       })
//         .then((res) => res.json())
//         .then((data) => {
//           setLoading(false);
//           setTokenData(data);
//         });
//     } else {
//       setLoading(false);
//     }
//   }, [url, API_URL]);

//   // Función actualizada que recibe la duración (en días) para enviar al backend
//   const generateUrl = (durationDays) => {
//     const ephToken = localStorage.getItem("eph-token");
//     const token = JSON.parse(ephToken)?.value;
//     fetch(`${API_URL}generate_code/${projectID}`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "x-access-token": token,
//       },
//       body: JSON.stringify({ duration: durationDays }),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         setCode(data.code);
//         setUrl(
//           `https://client.expertpowerhouse.com/${projectID}&code=${data.code}`
//         );
//       });
//   };

//   if (loading) return null;

//   return (
//     <div
//       style={{ display: "flex", justifyContent: "center", minWidth: "1366px" }}
//     >
//       <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//         <div
//           style={{
//             position: "relative",
//             display: "inline-flex",
//             alignItems: "center",
//           }}
//         >
//           <input
//             type="text"
//             value={!url ? "Generate a new url" : url}
//             readOnly
//             style={{
//               padding: "10px",
//               border: "1px solid #ccc",
//               borderRadius: "5px",
//               width: "500px",
//               color: "gray",
//             }}
//           />
//           {url.includes("http") &&
//           tokenData?.expiration > Math.trunc(Date.now() / 1000) &&
//           tokenData?.valid ? (
//             <>
//               <button
//                 onClick={copyToClipboard}
//                 style={{
//                   backgroundColor: copied ? "green" : "#365561",
//                   color: "white",
//                   border: "none",
//                   padding: "10px",
//                   marginLeft: "5px",
//                   cursor: "pointer",
//                   borderRadius: "5px",
//                   outline: "none",
//                 }}
//               >
//                 {copied ? "Copied!" : "Copy"}
//               </button>
//               <button
//                 onClick={() => handleOpenEmail()}
//                 style={{
//                   backgroundColor: "#365561",
//                   color: "white",
//                   border: "none",
//                   padding: "10px",
//                   marginLeft: "5px",
//                   cursor: "pointer",
//                   borderRadius: "5px",
//                   outline: "none",
//                 }}
//               >
//                 Email
//               </button>
//               <button
//                 onClick={() => setShowModal(true)}
//                 style={{
//                   backgroundColor: "#365561",
//                   color: "white",
//                   border: "none",
//                   padding: "10px",
//                   marginLeft: "5px",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Generate
//               </button>
//             </>
//           ) : (
//             // Al hacer click en Generate se abre el modal
//             <button
//               onClick={() => setShowModal(true)}
//               style={{
//                 backgroundColor: "#365561",
//                 color: "white",
//                 border: "none",
//                 padding: "10px",
//                 borderRadius: "5px",
//                 cursor: "pointer",
//               }}
//             >
//               Generate
//             </button>
//           )}
//         </div>
//         <span>
//           {tokenData?.expiration > Date.now() / 1000
//             ? `Link will expire in ${Math.floor(
//                 (tokenData?.expiration - Math.trunc(Date.now() / 1000)) / 86400
//               )} days`
//             : !tokenData?.valid
//             ? "Link expired generate a new one"
//             : null}
//         </span>
//       </div>

//       {/* Modal con el slider y los botones OK / Cancel */}
//       {showModal && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: "rgba(0,0,0,0.5)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 1000,
//           }}
//         >
//           <div
//             style={{
//               backgroundColor: "#fff",
//               padding: "20px",
//               borderRadius: "8px",
//               width: "400px",
//               textAlign: "center",
//             }}
//           >
//             <h3>Select Expiration Duration</h3>
//             <div style={{ margin: "20px 0" }}>
//               <input
//                 type="range"
//                 min={0}
//                 max={3}
//                 step={1}
//                 value={durationIndex}
//                 onChange={(e) => setDurationIndex(parseInt(e.target.value))}
//                 style={{ width: "100%" }}
//               />
//               <div style={{ marginTop: "10px", fontWeight: "bold" }}>
//                 {labels[durationIndex]}
//               </div>
//             </div>
//             <div style={{ display: "flex", justifyContent: "space-around" }}>
//               <button
//                 onClick={() => {
//                   // Al hacer click en OK se ejecuta generateUrl con la duración seleccionada y se cierra el modal
//                   generateUrl(durations[durationIndex]);
//                   setShowModal(false);
//                 }}
//                 style={{
//                   backgroundColor: "#365561",
//                   color: "white",
//                   border: "none",
//                   padding: "10px 20px",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 OK
//               </button>
//               <button
//                 onClick={() => setShowModal(false)}
//                 style={{
//                   backgroundColor: "#ccc",
//                   color: "black",
//                   border: "none",
//                   padding: "10px 20px",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CopyUrlComponent;


import { UrlContext } from "../../contexts/UrlContext";
import { UserContext } from "../../contexts/UserContext";
import React, { useContext, useEffect, useMemo, useState } from "react";
import ProjectClientEmail from "../EmailUI/ProjectClientEmail";

const DURATIONS = [30, 60, 180, 365];
const DURATION_LABELS = ["30 days", "2 months", "6 months", "1 year"];

const CopyUrlComponent = ({ projectID, projectName, projectSupporters, url, setUrl, handleOpenEmail, logFunction }) => {
  const { API_URL } = useContext(UrlContext);
  const { userData } = useContext(UserContext);

  const [copied, setCopied] = useState(false);
  const [linkedTextCopied, setLinkedTextCopied] = useState(false);
  const [tokenData, setTokenData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [durationIndex, setDurationIndex] = useState(0);
  const [openEmailClient, setOpenEmailClient] = useState(false);

  const isAdmin = userData?.roles?.includes("Admin");
  const isProjectSupporter = projectSupporters?.some(
    (supporter) =>
      String(supporter || "").trim().toLowerCase() ===
      String(userData?.username || "").trim().toLowerCase()
  );

  const canOpenClientEmails = isAdmin || isProjectSupporter;

  const safeUrl = typeof url === "string" ? url : "";
  const now = Math.trunc(Date.now() / 1000);
  const hasUrl = safeUrl.includes("http");

  const isActive =
    hasUrl &&
    tokenData?.valid === true &&
    Number(tokenData?.expiration) > now;

  const remainingDays = useMemo(() => {
    const expiration = Number(tokenData?.expiration);

    if (!Number.isFinite(expiration) || expiration <= now) {
      return 0;
    }

    return Math.max(0, Math.floor((expiration - now) / 86400));
  }, [tokenData?.expiration, now]);

  const copyToClipboard = async () => {
    if (!safeUrl) return;

    try {
      await navigator.clipboard.writeText(safeUrl);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch (error) {
      console.error("Could not copy client URL:", error);
    }
  };

  // Copy a named hyperlink for pasting into rich-text editors (e.g. Outlook).
  const copyLinkedText = async () => {
    if (!isActive) return;

    const label = "view shared profiles";

    try {
      const destination = new URL(safeUrl);
      if (!["http:", "https:"].includes(destination.protocol)) return;

      // Building the anchor through the DOM escapes URL characters safely.
      const anchor = document.createElement("a");
      anchor.href = destination.href;
      anchor.textContent = label;
      const html = anchor.outerHTML;

      if (navigator.clipboard?.write && typeof ClipboardItem !== "undefined") {
        await navigator.clipboard.write([
          new ClipboardItem({
            "text/html": new Blob([html], { type: "text/html" }),
            "text/plain": new Blob([`${label}: ${destination.href}`], { type: "text/plain" }),
          }),
        ]);
      } else {
        // Fallback for browsers without the asynchronous rich clipboard API.
        const temporary = document.createElement("div");
        temporary.contentEditable = "true";
        temporary.style.cssText = "position:fixed;left:-9999px;top:0;";
        temporary.appendChild(anchor);
        document.body.appendChild(temporary);

        try {
          temporary.focus();
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(temporary);
          selection.removeAllRanges();
          selection.addRange(range);

          if (!document.execCommand("copy")) {
            throw new Error("Rich-text clipboard copying is unavailable.");
          }
        } finally {
          window.getSelection()?.removeAllRanges();
          temporary.remove();
        }
      }

      setLinkedTextCopied(true);
      window.setTimeout(() => setLinkedTextCopied(false), 1800);
    } catch (error) {
      console.error("Could not copy linked client text:", error);
    }
  };

  useEffect(() => {
    if (!hasUrl) {
      setTokenData(null);
      setLoading(false);
      return undefined;
    }

    const code = safeUrl.split("&code=")[1]?.split("&")[0];

    if (!code) {
      setTokenData(null);
      setLoading(false);
      return undefined;
    }

    const controller = new AbortController();

    const validateLink = async () => {
      setLoading(true);

      try {
        const response = await fetch(`${API_URL}validate_code`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ code }),
          signal: controller.signal,
        });

        const data = await response.json();
        setTokenData(data);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Could not validate client URL:", error);
          setTokenData({
            valid: false,
            expiration: 0,
          });
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    validateLink();
    return () => controller.abort();
  }, [safeUrl, API_URL, hasUrl]);

  const generateUrl = async (durationDays) => {
    const ephToken = localStorage.getItem("eph-token");
    const token = ephToken ? JSON.parse(ephToken)?.value : null;

    setGenerating(true);

    try {
      const response = await fetch(
        `${API_URL}generate_code/${projectID}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
          body: JSON.stringify({
            duration: durationDays,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok || !data.code) {
        throw new Error(data.message || "Could not generate the link.");
      }

      setUrl(
        `https://client.expertpowerhouse.com/${projectID}&code=${data.code}`
      );
      setShowModal(false);
    } catch (error) {
      console.error("Could not generate client URL:", error);
    } finally {
      setGenerating(false);
    }
  };

  const statusLabel = loading
    ? "Checking"
    : isActive
      ? `${remainingDays}d left`
      : hasUrl
        ? "Expired"
        : "No link";

  const statusClasses = loading
    ? "bg-slate-100 text-slate-500"
    : isActive
      ? "bg-emerald-50 text-emerald-700"
      : hasUrl
        ? "bg-rose-50 text-rose-600"
        : "bg-slate-100 text-slate-500";

  return (
    <>
      <div className="flex w-full min-w-0 items-center gap-1.5 border-t border-b border-slate-200 bg-white px-4 py-1 shadow-sm">
        <div className="relative min-w-0 flex-1">
          <i className="fa-solid fa-link pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[11px] text-slate-400" />

          <input
            type="text"
            value={safeUrl || "Generate a new client link"}
            readOnly
            className="h-10 w-full min-w-0 truncate rounded-xl border-0 bg-slate-50 pl-8 pr-[220px] lg:pr-[305px] text-xs text-slate-300 hover:text-slate-600 outline-none sm:text-sm"
            aria-label="Client access URL"
          />

          <div className="absolute right-1 top-1/2 flex -translate-y-1/2 items-center gap-1">
            {/* Days left / status */}
            <span
              className={[
                "pointer-events-none rounded-full px-2 py-0.5 text-[9px] font-bold sm:text-[10px]",
                statusClasses,
              ].join(" ")}
            >
              {statusLabel}
            </span>

            {/* Copy */}
            {isActive && (
              <button
                type="button"
                onClick={copyToClipboard}
                title={copied ? "Copied" : "Copy link"}
                className={[
                  "inline-flex h-8 shrink-0 items-center justify-center gap-1 rounded-xl px-2 text-[11px] font-semibold transition focus:outline-none",
                  copied
                    ? "bg-emerald-600 text-white"
                    : "border border-slate-200 bg-white text-slate-600 hover:bg-[#365561]/10 hover:text-[#365561]",
                ].join(" ")}
              >
                <i className={`fa-solid ${copied ? "fa-check" : "fa-copy"}`} />
                <span className="hidden lg:inline">
                  {copied ? "Copied" : "Copy"}
                </span>
              </button>
            )}

            {/* Copy hyperlink as named text */}
            {isActive && (
              <button
                type="button"
                onClick={copyLinkedText}
                title={linkedTextCopied ? "Copied" : 'Copy "view shared profiles" as a clickable link'}
                className={[
                  "inline-flex h-8 shrink-0 items-center justify-center gap-1 rounded-xl px-2 text-[11px] font-semibold transition focus:outline-none",
                  linkedTextCopied
                    ? "bg-emerald-600 text-white"
                    : "border border-slate-200 bg-white text-slate-600 hover:bg-[#365561]/10 hover:text-[#365561]",
                ].join(" ")}
              >
                <i className={`fa-solid ${linkedTextCopied ? "fa-check" : "fa-font"}`} />
                <span className="hidden lg:inline">
                  {linkedTextCopied ? "Copied" : "Copy text"}
                </span>
              </button>
            )}

            {/* New / Generate */}
            <button
              type="button"
              onClick={() => setShowModal(true)}
              title={hasUrl ? "Generate a new link" : "Generate link"}
              className="inline-flex h-8 shrink-0 items-center justify-center gap-1 rounded-xl border border-slate-200 bg-white px-2 text-[11px] font-semibold text-slate-600 transition hover:bg-[#365561]/10 hover:text-[#365561] focus:outline-none"
            >
              <i className="fa-solid fa-rotate" />
              <span className="hidden lg:inline">
                {hasUrl ? "New" : "Generate"}
              </span>
            </button>
          </div>
        </div>

        {isActive && (
          <button
            type="button"
            onClick={handleOpenEmail}
            title="Send by email"
            className="inline-flex h-10 shrink-0 items-center justify-center gap-1.5 rounded-xl border border-slate-200 px-3 text-xs font-semibold text-slate-600 transition hover:bg-[#365561]/10 hover:text-[#365561] focus:outline-none"
          >
            <i className="fa-solid fa-envelope" />
            <span className="hidden md:inline">Email</span>
          </button>
        )}

        <button
          type="button"
          onClick={() => setOpenEmailClient(true)}
          title="Send by email"
          className="inline-flex h-10 shrink-0 items-center justify-center gap-1.5 rounded-xl border border-slate-200 px-3 text-xs font-semibold text-slate-600 transition hover:bg-[#365561]/10 hover:text-[#365561] focus:outline-none"
          disabled={!canOpenClientEmails}
        >
          <i class="fa-solid fa-envelopes-bulk"></i>
          <span className="hidden md:inline">Client emails</span>
          {/* <ToggleTooltip label={'Client emails log for this project'} isLeftEdge={false} isRightEdge={true} /> */}
        </button>
      </div>

      {showModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/40 p-3 backdrop-blur-sm">
          <div className="w-full max-w-sm rounded-3xl border border-slate-200 bg-white p-4 shadow-[0_24px_80px_rgba(15,23,42,0.32)] sm:p-5">
            <div className="flex items-start justify-between gap-3">
              <div>
                <h3 className="text-base font-semibold text-slate-900">
                  Link duration
                </h3>
                <p className="mt-1 text-xs text-slate-500">
                  Choose when this client link should expire.
                </p>
              </div>

              <button
                type="button"
                onClick={() => {
                  if (!generating) {
                    setShowModal(false);
                  }
                }}
                disabled={generating}
                className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-slate-200 text-slate-500 transition hover:bg-slate-50 hover:text-rose-500 disabled:opacity-50"
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark" />
              </button>
            </div>

            <div className="mt-5">
              <input
                type="range"
                min={0}
                max={3}
                step={1}
                value={durationIndex}
                disabled={generating}
                onChange={(event) =>
                  setDurationIndex(
                    Number.parseInt(event.target.value, 10)
                  )
                }
                className="w-full cursor-pointer accent-[#365561] disabled:cursor-not-allowed disabled:opacity-50"
              />

              <div className="mt-3 flex items-center justify-between gap-3 rounded-2xl bg-[#365561]/5 px-3 py-2.5">
                <span className="text-xs text-slate-500">Selected</span>
                <span className="text-xs font-semibold text-[#365561]">
                  {DURATION_LABELS[durationIndex]}
                </span>
              </div>
            </div>

            <div className="mt-5 flex justify-end gap-2">
              <button
                type="button"
                onClick={() => setShowModal(false)}
                disabled={generating}
                className="inline-flex h-10 items-center justify-center rounded-full border border-slate-200 px-4 text-xs font-semibold text-slate-600 transition hover:bg-slate-50 disabled:opacity-50"
              >
                Cancel
              </button>

              <button
                type="button"
                onClick={() => generateUrl(DURATIONS[durationIndex])}
                disabled={generating}
                className="inline-flex h-10 items-center justify-center gap-2 rounded-full bg-[#365561] px-4 text-xs font-semibold text-white transition hover:bg-[#2c4650] disabled:opacity-50"
              >
                {generating ? (
                  <i className="fa-solid fa-spinner fa-spin" />
                ) : (
                  <i className="fa-solid fa-link" />
                )}
                {generating ? "Generating" : "Generate"}
              </button>
            </div>
          </div>
        </div>
      )}

      {openEmailClient && (
        <ProjectClientEmail
          projectID={projectID}
          projectName={`${projectName}`}
          isLinkCreated={Boolean(url)}
          onClose={() => setOpenEmailClient(false)}
          logFunction={logFunction}
        />
      )}
    </>
  );
};

export default CopyUrlComponent;